module.exports = __webpack_public_path__ + "static/media/github.617870e4.svg";